import { FC } from 'react'

import DownloadIcon from 'images/icon-download.svg'

import cn from 'classnames'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

interface DownloadCSVButtonProps {
  className?: string
  onClick: () => void
}

export const DownloadCSVButton: FC<DownloadCSVButtonProps> = ({ className, onClick }) => {
  const { t } = useTranslation()

  return (
    <button className={cn(styles.downloadCSV, className)} onClick={onClick}>
      <img src={DownloadIcon} alt="icon download" />
      <p>{t('download_csv')}</p>
    </button>
  )
}
